import React from "react";

const Header = () => {
  return (
    <div className="card-header">
      <h4 className="card-title header">
        <span className="first">Q</span>uo<span>te</span>{" "}
        <span className="first">Ma</span>ch<span>ine</span>
      </h4>
    </div>
  );
};

export default Header;
